// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceTemplateEditor_editor_root__BxLxH {
  width: 850px;
  padding: 15px;
  color: var(--color-font-10);

  margin-right: auto;
  margin-left: auto;
  margin-bottom: 30px;
}


.InvoiceTemplateEditor_header__gVAi6 {
  display: flex;
  justify-content: space-between;
}
.InvoiceTemplateEditor_sub_header_row__MVsIs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.InvoiceTemplateEditor_description__Ni6Ay {
  font-size: 10px !important;
  margin-top: 0px;
  font-style: italic;
}
.InvoiceTemplateEditor_template_action_container__nYzpz {
  display: flex;
  flex-direction: column;
  margin-top: 11px;
}

.InvoiceTemplateEditor_preview_button__GDdAT {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 240px;
  height: 41px;
}
.InvoiceTemplateEditor_confirm_btn__IvrBU {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 41px;
  width: 240px;

  font-weight: bold !important;
  margin: 5px 0px !important;
}
.InvoiceTemplateEditor_template_header__dIBN7 {
  width: 45%;
}
.InvoiceTemplateEditor_TwoInputs__UJ6V4 {
  display: flex;
  justify-content: space-between;
}
.InvoiceTemplateEditor_subInput__-QWUH {
  width: 45% !important ;
}
.InvoiceTemplateEditor_block__cUG6m {
  display: flex;
  justify-content: space-between;
}
.InvoiceTemplateEditor_left__qzLNm {
  width: 48%;
}
.InvoiceTemplateEditor_right__DQ13a {
  width: 48%;
}
.InvoiceTemplateEditor_left3__iajlC {
  width: 32%;
}
.InvoiceTemplateEditor_right3__KspnM {
  width: 32%;
}
.InvoiceTemplateEditor_middle3__VMMCm {
  width: 32%;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InvoiceTemplateEditor/InvoiceTemplateEditor.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;;EAE3B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;;EAEZ,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ","sourcesContent":[".editor_root {\n  width: 850px;\n  padding: 15px;\n  color: var(--color-font-10);\n\n  margin-right: auto;\n  margin-left: auto;\n  margin-bottom: 30px;\n}\n\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n.sub_header_row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.description {\n  font-size: 10px !important;\n  margin-top: 0px;\n  font-style: italic;\n}\n.template_action_container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 11px;\n}\n\n.preview_button {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 240px;\n  height: 41px;\n}\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 41px;\n  width: 240px;\n\n  font-weight: bold !important;\n  margin: 5px 0px !important;\n}\n.template_header {\n  width: 45%;\n}\n.TwoInputs {\n  display: flex;\n  justify-content: space-between;\n}\n.subInput {\n  width: 45% !important ;\n}\n.block {\n  display: flex;\n  justify-content: space-between;\n}\n.left {\n  width: 48%;\n}\n.right {\n  width: 48%;\n}\n.left3 {\n  width: 32%;\n}\n.right3 {\n  width: 32%;\n}\n.middle3 {\n  width: 32%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor_root": `InvoiceTemplateEditor_editor_root__BxLxH`,
	"header": `InvoiceTemplateEditor_header__gVAi6`,
	"sub_header_row": `InvoiceTemplateEditor_sub_header_row__MVsIs`,
	"description": `InvoiceTemplateEditor_description__Ni6Ay`,
	"template_action_container": `InvoiceTemplateEditor_template_action_container__nYzpz`,
	"preview_button": `InvoiceTemplateEditor_preview_button__GDdAT`,
	"confirm_btn": `InvoiceTemplateEditor_confirm_btn__IvrBU`,
	"template_header": `InvoiceTemplateEditor_template_header__dIBN7`,
	"TwoInputs": `InvoiceTemplateEditor_TwoInputs__UJ6V4`,
	"subInput": `InvoiceTemplateEditor_subInput__-QWUH`,
	"block": `InvoiceTemplateEditor_block__cUG6m`,
	"left": `InvoiceTemplateEditor_left__qzLNm`,
	"right": `InvoiceTemplateEditor_right__DQ13a`,
	"left3": `InvoiceTemplateEditor_left3__iajlC`,
	"right3": `InvoiceTemplateEditor_right3__KspnM`,
	"middle3": `InvoiceTemplateEditor_middle3__VMMCm`
};
export default ___CSS_LOADER_EXPORT___;
